export enum ChatsOrderColumn {
  OFFER = "OFFER",
  OFFER_REQUEST = "OFFER_REQUEST",
  IS_ADMIN_INVITED = "IS_ADMIN_INVITED",
  IS_ABOUT_RECLAMATION = "IS_ABOUT_RECLAMATION",
}
